<template>
    <div class="row">
        <div class="col-12 col-md-6">
            <h2>{{ legalMentions.guaranteeTitle }}</h2>
        </div>
        <div id="anchor-guarantee-legal-mentions" class="col-12 col-md-6">
            <p class="mb-1" v-html="legalMentions.guaranteeText" />
        </div>
    </div>
</template>

<script>
export default {
    name: "GuaranteeLegalMentions",
    props: {
        legalMentions: {
            type: Object,
            required: true
        }
    },
}
</script>
